import { arClient } from "@/api/ar-client";
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        idArClient: {
            type: Number,
            default: 0
        }
    },
    data(){
        return {
            headersListHistory: [
                {
                    key: 'BookingCode',
                    label: this.$t('ar_client_booking_code'),
                    class: 'text-truncate'
                },
                {
                    key: 'BillCode',
                    label: this.$t('ar_client_bill_code'),
                    class: 'text-truncate'
                },
                {
                    key: 'CreateDate',
                    label: this.$t('ar_client_invoice_creation_date'),
                    class: 'text-truncate'
                },
                {
                    key: 'MoneyNumber',
                    label: this.$t('ar_client_money_number'),
                    class: 'text-truncate'
                },
                {
                    key: 'Allotment',
                    label: this.$t('ar_client_allotment'),
                    class: 'text-truncate'
                },
                {
                    key: 'PaymentTime',
                    label: this.$t('ar_client_payment_time'),
                    class: 'text-truncate'
                },
            ],
            perPage: 10,
            currentPage: 1,
        }
    },
    methods: {
        closeSidebar() {
            this.isOpen = false;
        },
        fecthData_AR_RAAD01() {
            const body = {
                ArAccount: {
                    Id: this.idArClient,
                }
            }
            arClient.api_AR_RAAD01(body).then((res) => {
                if (res.Status !== "200") {
                    this.showResToast(res);
                    return;
                  }
                
            })
        }
    },
    watch: {
        isOpen(value) {
            this.$emit('update:isOpen', value);
            if (!value) {
                return;
            }
            
            this.fecthData_AR_RAAD01();
        }
    },
}